import Model from './Model';

export default class Register extends Model {
  resource() {
    return 'auth/register';
  }
}
